import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { getFieldErrors } from "../helpers";
import { IUser, tryConfirmLogin } from "./authReducer";


export interface IVehicle {
    _id: string;
    type?: string;
    number?: string;
}

export interface IAdmin extends IUser {
}

export interface IAdminsState {
    fetchingAdmins: boolean;
    fetchAdminsErr: string | null;
    admins: IAdmin[];
    fetchingMainAdmin: boolean;
    fetchMainAdminErr: string | null;
    mainAdminId: string | null;
    mainAdmin: IAdmin | null;
}

const initialState = {
    // mainAdmin: {
    //     _id: 'oiwewioidecd',
    //     imgSrc: '',
    //     firstName: 'Olamide',
    //     lastName: 'Falade',
    //     email: 'ofalade326@stu.ui.edu.ng',
    //     emailVerified: true,
    //     status: 'active',
    //     ordersCount: 3,
    //     pickUpsCount: 2,
    // },
    fetchingAdmins: false,
    fetchAdminsErr: null,
    admins: [],
    fetchingMainAdmin: false,
    fetchMainAdminErr: null,
    mainAdminId: null,
    mainAdmin: null,
} as IAdminsState;


const adminsSlice = createSlice({
    name: 'admins',
    initialState,
    reducers: {
        fetchAdminsStart: (state: IAdminsState) => {
            state.fetchingAdmins = true;
        },
        fetchAdminsPass: (state: IAdminsState, action: PayloadAction<IAdmin[]>) => {
            state.fetchingAdmins = false;

            state.admins = action.payload;
        },
        fetchAdminsFail: (state: IAdminsState, action: PayloadAction<string>) => {
            state.fetchingAdmins = false;
            state.fetchAdminsErr = action.payload;
        },
        clearFetchMainAdminErr: (state: IAdminsState) => {
            state.fetchMainAdminErr = null;
        },
        fetchMainAdminStart: (state: IAdminsState) => {
            state.fetchingMainAdmin = true;
            state.fetchMainAdminErr = null;
        },
        fetchMainAdminPass: (state: IAdminsState, action: PayloadAction<IAdmin>) => {
            state.fetchingMainAdmin = false;
            state.mainAdmin = action.payload;

        },
        fetchMainAdminFail: (state: IAdminsState, action: PayloadAction<string>) => {
            state.fetchingMainAdmin = false;
            state.fetchMainAdminErr = action.payload;
        },
        setMainAdminId: (state: IAdminsState, action: PayloadAction<string | null>) => {
            state.mainAdminId = action.payload;
        },
        setMainAdmin: (state: IAdminsState, action: PayloadAction<IAdmin | null>) => {
            state.mainAdmin = action.payload;
        }
    }

})

export const {
    fetchAdminsStart,
    fetchAdminsPass,
    fetchAdminsFail,
    clearFetchMainAdminErr,
    fetchMainAdminStart,
    fetchMainAdminPass,
    fetchMainAdminFail,
    setMainAdmin,
    setMainAdminId,
} = adminsSlice.actions;


interface ITryFetchAdminsArg {
    authToken: string;
}


export const tryFetchAdmins = createAsyncThunk('customers/tryFetchAdmins', (arg: ITryFetchAdminsArg, { dispatch }) => {
    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/admins`;

    const { authToken } = arg;

    dispatch(fetchAdminsStart());
    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        dispatch(fetchAdminsPass(res.data));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({authToken}));
            return;
        }

        if (data?.err) {
            dispatch(fetchAdminsFail(data.err));
        } else {
            dispatch(fetchAdminsFail('Check your network connection.'))
        }

    });
});


interface ITryFetchMainAdminArg {
    authToken: string;
    adminId: string;
}

export const tryFetchMainAdmin = createAsyncThunk('admins/tryFetchMainAdmin', (arg: ITryFetchMainAdminArg, { dispatch }) => {
    const { authToken, adminId } = arg;

    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/admins/${adminId}`;

    dispatch(fetchMainAdminStart());
    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        const data = res.data;
        dispatch(fetchMainAdminPass(res.data));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({authToken}));
            return;
        }

        if (data?.errors) {
            dispatch(fetchMainAdminFail(getFieldErrors(data.errors)[0].msg));
        } else if (data?.err) {
            dispatch(fetchMainAdminFail(data.err));
        } else {
            dispatch(fetchMainAdminFail('Check your network connection.'));
        }
    });
});

export default adminsSlice.reducer;

